// The first key is the locale, the rest are polyglot phrases.
export const DEFAULT_PHRASES = {
    sv: {
        validation: {
            required: 'Fältet är obligatoriskt.',
            ISO08601: 'Var god ange ett giltigt datum enligt ÅÅÅÅ-MM-DD.',
            isoDate: 'Var god ange ett giltigt datum enligt ÅÅÅÅ-MM-DD.',
            isoDateWithTime: 'Var god ange ett giltigt datum enligt ÅÅÅÅ-MM-DD HH:mm:ss.',
            maxDate: 'Datumet får inte vara efter %{value}.',
            beforeToday: 'Datumet får inte vara efter dagens datum.',
            minDate: 'Datumet får inte vara före %{value}.',
            birthDate: 'Ange ett datum senare än patientens födelsedatum (%{date}).',
            deathDate: 'Ange ett datum tidigare än patientens dödsdatum (%{date}).',
            year: 'Var god ange ett giltigt år enligt ÅÅÅÅ.',
            integer: 'Var god ange ett giltigt heltal.',
            pattern: 'Var god ange ett värde enligt specifierat pattern.',
            float: 'Var god ange ett giltigt decimaltal.',
            boolean: 'Var god ange sant/falskt.',
            number: 'Var god ange ett nummer.',
            min: 'Värdet måste vara minst %{value}.',
            max: 'Värdet får vara max %{value}.',
            digits: 'Var god ange endast siffror.',
            range: 'Var god ange ett värde mellan %{min} och %{max}.',
            email: 'Var god ange en giltig e-postadress.',
            minLength: 'Var god ange minst %{value} tecken.',
            maxLength: 'Var god ange max %{value} tecken.',
            rangeLength: 'Var god ange ett värde mellan %{min} och %{max} tecken.',
            validCharacters: 'Följande tecken är tillåtna: %{value}',
            invalid: 'Angivet värde är ogiltigt.',
            minSelected: 'Minst %{smart_count} alternativ måste väljas.',
            maxSelected: 'Max %{smart_count} alternativ måste väljas.'
        },
        component: {
            calendar: {
                today: 'Dagens datum'
            },
            reviewform: {
                header: 'Granskning av formulär',
                errors: 'Följande fel hittades:',
                warnings: 'Följande varningar hittades:',
                errorsCount: 'Antal fel hittade',
                warningsCount: 'Antal varningar hittade',
                success: 'Inga fel eller varningar hittades!',
                warningsSuccess: 'Inga varningar hittades!',
                errorsSuccess: 'Inga fel hittades!'
            },
            designedform: {
                warningsAlert: 'Formuläret innehåller varningar. Är du säker på att du vill spara?',
                unsavedAlert: 'Det finns osparade ändringar i formuläret. Är du säker på att du vill lämna sidan?',
                // TODO: Nån bra lösning för text med jsx? För errormodalen. bl. a.
                header: 'Fel funna i formuläret',
                p1: 'Det saknas information eller finns fel i de inmatade uppgifterna i formuläret.',
                p2: 'De flikar och rader som innehåller fel har rödmarkerats. För att kunna spara behöver åtminstone felen åtgärdas.',
                total: 'Totalt finns det',
                errors: 'fel',
                and: 'och',
                warnings: 'varning. |||| varningar.'
            },
            ajaxloader: {
                progress: '%{numLoaded} av %{numTotal}',
                loading: 'Laddar, var god vänta...'
            },
            dropdownlist: {
                empty: 'Inga träffar.',
                more: 'Visa fler'
            },
            listbuttongroup: {
                caption: '[värde saknas]'
            },
            multiboolquestion: {
                placeholder: 'Välj kryssrutor'
            },
            personuppgifter: {
                deceased: 'Avliden',
                ssn: 'Personnummer',
                lastname: 'Efternamn',
                firstname: 'Förnamn',
                address: 'Gatuadress',
                postalcode: 'Postnummer',
                city: 'Postadress',
                gender: 'Kön',
                deathdate: 'Dödsdatum',
                lk: 'LK',
                district: 'Distriktskod',
                lkdia: 'LK vid diagnos'
            },
            positionselector: {
                minlengthhospital: 'Sjukhuskoden avviker från den vanliga 4-6-ställiga koden och kan behöva justeras manuellt.',
                minlengthclinic: 'Klinikkoden avviker från den vanliga 3-ställiga koden och kan behöva justeras manuellt.'
            },
            grid: {
                loading: 'Laddar...',
                filterPlaceholder: 'Sök i samtliga kolumner',
                filter: 'Filter',
                resetFilter: 'Återställ filtrering',
                applyFilter: 'Filtrera',
                noRowsFound: 'Inga rader hittades.',
                pager: {
                    itemsPerPage: 'Antal per sida',
                    showingNumRows: 'Visar rad %{rows_visible} av %{rows_total}',
                    first: 'Första',
                    last: 'Sista',
                    next: 'Nästa',
                    prev: 'Föregående'
                }
            }
        },
        regvar: {
            date: {
                placeholder: 'ÅÅÅÅ-MM-DD'
            },
            list: {
                caption: '- Välj -',
                other: 'Övriga'
            }
        },
        button: {
            remove: 'Ta bort',
            close: 'Stäng',
            saveAnyway: 'Spara ändå'
        },
        error: {
            unexpected: 'Ett oväntat fel uppstod'
        },
        subtable: {
            empty: 'Tabellen är tom.'
        }
    },
    en: {
        validation: {
            required: 'The field is required.',
            ISO08601: 'Please enter a valid date according to YYYY-MM-DD.',
            isoDate: 'Please enter a valid date according to YYYY-MM-DD.',
            isoDateWithTime: 'Please enter a valid date according to YYYY-MM-DD HH:mm:ss.',
            maxDate: "The date can't be after %{value}.",
            beforeToday: "The date can't be after todays date.",
            minDate: "The date can't be before %{value}.",
            birthDate: 'Enter a date after the patients date of birth (%{date}).',
            deathDate: 'Enter a date before the patients date of death (%{date}).',
            year: 'Please enter a valid year according to YYYY.',
            integer: 'Please enter a valid integer.',
            pattern: 'Please enter a value according to the specified pattern.',
            float: 'Please enter a valid decimal.',
            boolean: 'Please enter true/false.',
            number: 'Please enter a number.',
            min: 'Minimum allowed value is %{value}.',
            max: 'Maximum allowed value is %{value}.',
            digits: 'Please enter digits only.',
            range: 'Please enter a value between %{min} and %{max}.',
            email: 'Please enter a valid email.',
            minLength: 'Please enter at least %{value} characters.',
            maxLength: 'Please enter at most %{value} characters.',
            rangeLength: 'Please enter a value between %{min} and %{max} characters.',
            validCharacters: 'Following characters are allowed: %{value}',
            invalid: 'Entered value is invalid.',
            minSelected: 'At least %{smart_count} option must be selected. |||| At least %{smart_count} options must be selected.',
            maxSelected: 'At most %{smart_count} option can be selected. |||| At most %{smart_count} options can be selected.'
        },
        component: {
            calendar: {
                today: 'Todays date'
            },
            reviewform: {
                header: 'Form review',
                errors: 'The following errors were found:',
                warnings: 'The following warnings were found:',
                errorsCount: 'Number of errors found',
                warningsCount: 'Number of warnings found',
                success: 'No errors or warnings were found!',
                warningsSuccess: 'No warnings were found!',
                errorsSuccess: 'No errors were found!'
            },
            designedform: {
                warningsAlert: 'The form contains warnings. Are you sure you want to save?',
                unsavedAlert: 'There are unsaved changes in the form. Are you sure you want to leave this page?',
                // TODO: Nån bra lösning för text med jsx? För errormodalen.
                header: 'Errors found in form',
                p1: 'There are errors or missing information in data entered in the form.',
                p2: 'The tabs and rows containing errors have been marked red. In order to save, the errors must be fixed.',
                total: 'In total there is |||| In total there are',
                errors: 'error |||| errors',
                and: 'and',
                warnings: 'warning. |||| warnings.'
            },
            ajaxloader: {
                progress: '%{numLoaded} of %{numTotal}',
                loading: 'Loading, please wait...'
            },
            dropdownlist: {
                empty: 'No results.',
                more: 'Show more'
            },
            listbuttongroup: {
                caption: '[value missing]'
            },
            multiboolquestion: {
                placeholder: 'Select checkboxes'
            },
            personuppgifter: {
                deceased: 'Deceased',
                ssn: 'Personal identity number',
                lastname: 'Lastname',
                firstname: 'Firstname',
                address: 'Street address',
                postalcode: 'Postal code',
                city: 'City',
                gender: 'Gender',
                deathdate: 'Date of death',
                lk: 'LK',
                district: 'District code',
                lkdia: 'LK at diagnosis'
            },
            positionselector: {
                minlengthhospital: 'Hospital code differs from the usual length of 4-6 digits and might need manual adjustment.',
                minlengthclinic: 'Clinic code differs from the usual length of 3 digits and might need manual adjustment.'
            },
            grid: {
                loading: 'Loading...',
                filterPlaceholder: 'Search in all columns',
                filter: 'Filter',
                resetFilter: 'Reset filter',
                applyFilter: 'Filter',
                noRowsFound: 'No rows found.',
                pager: {
                    itemsPerPage: 'Rows per page',
                    showingNumRows: 'Showing row %{rows_visible} of %{rows_total}',
                    first: 'First',
                    last: 'Last',
                    next: 'Next',
                    prev: 'Previous'
                }
            }
        },
        regvar: {
            date: {
                placeholder: 'YYYY-MM-DD'
            },
            list: {
                caption: '- Select -',
                other: 'Other'
            }
        },
        button: {
            remove: 'Remove',
            close: 'Close',
            saveAnyway: 'Save anyway'
        },
        error: {
            unexpected: 'An unexpected error occurred'
        },
        subtable: {
            empty: 'Table is empty.'
        }
    }
};
